<template>
  <img style="cursor:pointer"
       :src="assetImageUrl"
       alt="image"
       @click="open()">
  <div style="cursor:pointer"
       v-if="show"
       class="modal"
       @click="close()">
    <div class="body">
      <img :src="assetImageUrl" alt="image"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageModal',
  props: ["imageUrl"],
  data() {
    return {
      show: false,
    }
  },
  computed: {
    assetImageUrl() {
      if (this.imageUrl === undefined) {
        return ''
      }

      if (!this.imageUrl.startsWith('~@/assets')) {
        return this.imageUrl
      } else {
        return require('../../assets' + this.imageUrl.substring(9))
      }
    }
  },
  methods: {
    close() {
      this.show = false
    },
    open() {
      this.show = true
    }
  }
}
</script>

<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;
}

.modal .body {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

</style>
